<template>
    <div class="pages">
        <div class="header">
            <div class="header-title">
                <p>{{ pageTitle.cn }}</p><p>{{ pageTitle.en }}</p>
            </div>
        </div>
        <div class="container">
            <van-form @submit="onSubmit">
                <div class="contract">
                    <div class="contract-home">
                        <p class="contract-no">GF-2021-2607</p>
                        <p class="contract-name">农村土地经营权入股合同</p>
                        <div class="contract-company">
                            <p>农业农村部</p>
                            <p>国家市场监督管理总局</p>
                        </div>
                        <p class="contract-zd">制定</p>
                    </div>
                    <div class="contract-text">
                        <p class="contract-text-title">使用说明</p>
                        <p class="contract-text-content">
                            一、本合同为示范文本，由农业农村部与国家市场监督管理总局联合制定，供农村土地（耕地）经营权入股的当事人签订合同时参照使用。
                        </p>
                        <p class="contract-text-content">
                            二、合同签订前，双方当事人应当仔细阅读本合同内容，特别是其中具有选择性、补充性、填充性、修改性的内容；对合同中的专业用词理解不一致的，可向当地农业农村部门或农村经营管理部门咨询。
                        </p>
                        <p class="contract-text-content">
                            三、合同签订前，工商企业等社会资本通过入股取得土地经营权的，应当依法履行资格审查、项目审核和风险防范等相关程序。
                        </p>
                        <p class="contract-text-content">
                            四、本合同文本中相关条款后留有空白行，供双方自行约定或者补充约定。双方当事人依法可以对文本条款的内容进行修改、增补或者删减。合同签订生效后,未被修改的文本印刷文字视为双方同意内容。
                        </p>
                        <p class="contract-text-content">
                            五、双方当事人应当结合具体情况选择本合同协议条款中所提供的选择项，同意的在选择项前的□打√，不同意的打×。
                        </p>
                        <p class="contract-text-content">
                            六、本合同文本中涉及到的选择、填写内容以手写项为优先。
                        </p>
                        <p class="contract-text-content">
                            七、当事人订立合同的，应当在合同书上签字、盖章或者按指印。
                        </p>
                        <p class="contract-text-content">
                            八、本合同文本“当事人”部分，自然人填写身份证号码，农村集体经济组织填写农业农村部门赋予的统一社会信用代码，其他市场主体填写市场监督管理部门赋予的统一社会信用代码。
                        </p>
                        <p class="contract-text-content">
                            九、本合同编号由县级以上农业农村部门或农村经营管理部门指导乡（镇）人民政府农村土地承包管理部门按统一规则填写。
                        </p>
                    </div>
                    <div class="contract-text contract-sm">
                        根据《中华人民共和国民法典》《中华人民共和国农村土地承包法》和《农村土地经营权流转管理办法》等相关法律法规，本着平等、自愿、公平、诚信、有偿的原则，经甲乙双方协商一致，就土地经营权入股事宜，签订本合同。
                    </div>
                    <div class="contract-content">
                        <p class="contract-titles">一、当事人</p>
                        <p class="contract-block contract-flex">甲方（入股方）：<van-field v-model="cf.party" input-align="center" style="width: 140px"/></p>
                        <div class="contract-block contract-flex"><a-checkbox>社会信用代码：</a-checkbox><van-field v-model="cf.partySocialCreditCode" input-align="center" style="width: 140px"/></div>
                        <div class="contract-block contract-flex"><a-checkbox>身份证号码：</a-checkbox><van-field v-model="cf.partyIdCard" input-align="center" style="width: 140px"/></div>
                        <div class="contract-block contract-flex">法定代表人（负责人/农户代表人）：<van-field v-model="cf.partyLegalRepresentative" input-align="center" style="width: 60px"/></div>
                        <div class="contract-block contract-flex">身份证号码：<van-field v-model="cf.partyLegalRepresentativeIdCard" input-align="center" style="width: 160px"/></div>
                        <div class="contract-block contract-flex">联系地址：<van-field v-model="cf.partyLegalRepresentativeAddress" input-align="center" style="width: 160px"/></div>
                        <div class="contract-block contract-flex">联系电话：<van-field v-model="cf.partyLegalRepresentativePhone" input-align="center" style="width: 160px"/></div>
                        <div class="contract-block contract-flex">经营主体类型：
                            <a-checkbox-group
                                :options="['自然人', '农村承包经营户', '农民专业合作社', '家庭农场', '农村集体经济组织', '公司']"
                                v-model:value="cf.partyBusinessEntityType"
                            />
                            <a-checkbox>其他:</a-checkbox><van-field v-model="cf.partyBusinessEntityTypeOther" input-align="center" style="width: 100px"/>
                        </div>
                        <hr>
                        <div class="contract-block contract-flex">乙方（受让方）：<van-field v-model="cf.sParty" input-align="center" style="width: 160px"/></div>
                        <div class="contract-block contract-flex"><a-checkbox>社会信用代码：</a-checkbox><van-field v-model="cf.sPartySocialCreditCode" input-align="center" style="width: 140px"/></div>
                        <div class="contract-block contract-flex"><a-checkbox>身份证号码：</a-checkbox><van-field v-model="cf.sPartyIdCard" input-align="center" style="width: 140px"/></div>
                        <div class="contract-block contract-flex">法定代表人（负责人/农户代表人）：<van-field v-model="cf.sPartyLegalRepresentative" input-align="center" style="width: 60px"/></div>
                        <div class="contract-block contract-flex">身份证号码：<van-field v-model="cf.sPartyLegalRepresentativeIdCard" input-align="center" style="width: 160px"/></div>
                        <div class="contract-block contract-flex">联系地址：<van-field v-model="cf.sPartyLegalRepresentativeAddress" input-align="center" style="width: 160px"/></div>
                        <div class="contract-block contract-flex">联系电话：<van-field v-model="cf.sPartyLegalRepresentativePhone" input-align="center" style="width: 160px"/></div>
                        <div class="contract-block contract-flex">经营主体类型：
                            <a-checkbox-group
                                :options="['农民专业合作社', '公司']"
                                v-model:value="cf.sPartyBusinessEntityType"
                            />
                            <a-checkbox>其他:</a-checkbox><van-field v-model="cf.sPartyBusinessEntityTypeOther" input-align="center" style="width: 100px"/>
                        </div>
                        <p class="contract-titles">二、入股标的物</p>
                        <div class="contract-block contract-flex">
                            （一）经自愿协商，甲方将<van-field v-model="cf.acresCount" input-align="center" style="width: 40px"/>亩土地经营权（具体见下表及附图）入股乙方。
                        </div>
                        <div class="contract-block">
                            <div class="contract-table">
                                <a-table :columns="columns" :data-source="dataSource" bordered :pagination="false">
                                    <template v-for="col in ['village', 'landParcelName', 'landParcelCode', 'locatedEast', 'locatedSouth', 'locatedWest', 'locatedNorth', 'area', 'qualityGrade', 'landParcelType', 'contractCode', 'remark']" #[col]="{ text, record }">
                                        <div :key="col">
                                            <a-input
                                                v-if="editableData[record.key]"
                                                v-model:value="editableData[record.key][col]"
                                                style="margin: -5px 0"
                                            />
                                            <template v-else>
                                                {{ text }}
                                            </template>
                                        </div>
                                    </template>
                                    <template #operation="{ record }">
                                        <div class="editable-row-operations">
                                            <span v-if="editableData[record.key]">
                                              <a @click="save(record.key)">保存</a>
                                              <a-popconfirm title="Sure to cancel?" @confirm="cancel(record.key)">
                                                <a>取消</a>
                                              </a-popconfirm>
                                            </span>
                                            <span v-else>
                                              <a @click="edit(record.key)">编辑</a>
                                            </span>
                                        </div>
                                    </template>
                                </a-table>
                                <a-button class="editable-add-btn" @click="handleAdd" style="margin-bottom: 8px">添加</a-button>
                            </div>
                        </div>
                        <div class="contract-block contract-flex">
                            （二）入股土地上的附属建筑和资产情况现状描述：
                            <van-field v-model="cf.assetDescription" input-align="center" style="width: 100%"/>
                            入股土地上的附属建筑和资产的处置方式描述（可另附件）：
                            <van-field v-model="cf.descriptionOfDisposal" input-align="center" style="width: 100%"/>
                        </div>
                        <p class="contract-titles">三、入股土地用途</p>
                        <div class="contract-block contract-flex">
                            入股土地用途为<van-field v-model="cf.landUseForLease" input-align="center" style="width: 140px"/>
                        </div>
                        <p class="contract-titles">四、入股期限</p>
                        <div class="contract-block contract-flex">
                            入股期限自
                            <van-field v-model="cf.sharesStartTime" input-align="center" style="width: 100px"/>
                            起至
                            <van-field v-model="cf.sharesEndTime" input-align="center" style="width: 100px"/>止。
                        </div>
                        <p class="contract-titles">五、入股土地交付时间</p>
                        <div class="contract-block contract-flex">
                            甲方应于
                            <van-field v-model="cf.landDeliveryTime" input-align="center" style="width: 100px"/>
                            前完成土地交付。
                        </div>
                        <p class="contract-titles">六、股份分红及支付方式</p>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">（一）股份分红标准</div>
                            <div class="contract-block contract-flex">
                                双方当事人约定入股土地所占的
                                <a-radio-group v-model="cf.shareStandard">
                                    <a-radio :value="'出资额'">出资额</a-radio>
                                    <a-radio :value="'股份数'">股份数</a-radio>
                                </a-radio-group>
                                <van-field v-model="cf.perMuRmb" input-align="center" style="width: 60px"/>（大写：<van-field v-model="cf.perMuRmbUppercase" input-align="center" style="width: 100px"/>）
                                <a-checkbox>其他:</a-checkbox><van-field v-model="cf.perMuOther" input-align="center" style="width: 60px"/>
                            </div>
                            <div class="contract-block contract-flex">
                                双方当事人选择第
                                <a-select default-value="1" style="width: 60px" v-model:value="cf.shareStandardKind" :size="'small'">
                                    <a-select-option value="1">1</a-select-option>
                                    <a-select-option value="2">2</a-select-option>
                                </a-select>种股份分红标准
                            </div>
                            <div class="contract-block contract-flex" v-show="cf.shareStandardKind === '1'">
                                1.按股分红。即根据
                                <a-checkbox-group
                                    :options="['出资额', '股份数']"
                                    v-model:value="cf.pressShareKind"
                                />
                                <a-checkbox>其他:</a-checkbox><van-field v-model="cf.pressShareKindOther" input-align="center" style="width: 60px"/>分配盈余或者利润。
                            </div>
                            <div class="contract-block contract-flex" v-show="cf.shareStandardKind === '2'">
                                2.保底收益+按股分红。保底收益每亩每年
                                <van-field v-model="cf.minimumRevenue" input-align="center" style="width: 60px"/>元（大写：<van-field v-model="cf.minimumRevenueUppercase" input-align="center" style="width: 100px"/>），
                                每<van-field v-model="cf.minimumRevenueAdjustYear" input-align="center" style="width: 60px"/>年调整一次保底收益。具体调整方式：<van-field v-model="cf.minimumRevenueAdjust" input-align="center" style="width: 160px"/>。
                                <div class="contract-block contract-flex">
                                    按股分红。根据
                                    <a-checkbox-group
                                        :options="['出资额', '股份数']"
                                        v-model:value="cf.shareReason"
                                    />
                                    <a-checkbox>其他:</a-checkbox><van-field v-model="cf.shareReasonOther" input-align="center" style="width: 60px"/>分配盈余或者利润。
                                </div>
                            </div>
                            <div class="contract-block contract-flex" v-show="cf.shareStandardKind === '3'">
                                3.其他：<van-field v-model="cf.shareStandardOther" input-align="center" style="width: 160px"/>
                            </div>
                            <div class="contract-block">（二）股份分红支付</div>
                            <div class="contract-block contract-flex">双方当事人选择第
                                <a-select default-value="1" style="width: 60px" v-model:value="cf.sharePayType" :size="'small'">
                                    <a-select-option value="1">1</a-select-option>
                                    <a-select-option value="2">2</a-select-option>
                                </a-select>
                                种方式支付股份分红。</div>
                            <div class="contract-block contract-flex" v-show="cf.sharePayType === '1'">
                                <div class="contract-block contract-flex">1.按股分红。</div>
                                乙方须于每年
                                <van-field v-model="cf.shareFpTime" input-align="center" style="width: 40px"/>
                                前分配
                                （
                                <a-checkbox-group
                                    :options="['前一', '后']"
                                    v-model:value="cf.shareFpType"
                                />
                                ）年盈余或者利润。
                            </div>
                            <div class="contract-block contract-flex" v-show="cf.sharePayType === '2'">
                                <div class="contract-block contract-flex">2.保底收益＋按股分红。</div>
                                乙方须于每年
                                <van-field v-model="cf.shareRevenueTime" input-align="center" style="width: 40px"/>
                                前支付（
                                <a-checkbox-group
                                    :options="['当', '后一']"
                                    v-model:value="cf.shareRevenueType"
                                />
                                ）年保底收益<van-field v-model="cf.shareYearMinimumRevenue" input-align="center" style="width: 60px"/>元（大写：<van-field v-model="cf.shareYearMinimumRevenueUppercase" input-align="center" style="width: 100px"/>）。
                                乙方须于每年
                                <van-field v-model="cf.shareRevenueFpTime" input-align="center" style="width: 40px"/>
                                前分配（
                                <a-checkbox-group
                                    :options="['前一', '当']"
                                    v-model:value="cf.shareRevenueFpTimeType"
                                />
                                ）年盈余或者利润。
                            </div>
                            <div class="contract-block contract-flex" v-show="cf.sharePayType === '3'">
                                <div class="contract-block contract-flex">3.其他：<van-field v-model="cf.sharePayOther" input-align="center" style="width: 160px"/></div>
                            </div>
                            <div class="contract-block">（二）付款方式</div>
                            <div class="contract-block contract-flex">双方当事人选择第
                                <a-select default-value="1" style="width: 60px" v-model:value="cf.paymentType" :size="'small'">
                                    <a-select-option value="1">1</a-select-option>
                                    <a-select-option value="2">2</a-select-option>
                                </a-select>
                                种付款方式。</div>
                            <div class="contract-block contract-flex" v-show="cf.paymentType === '1'">1.现金</div>
                            <div class="contract-block contract-flex" v-show="cf.paymentType === '2'">2.甲方账户名称：<van-field v-model="cf.paymentTypePartyAccountName" input-align="center" style="width: 140px"/></div>
                            <div class="contract-block contract-flex" v-show="cf.paymentType === '2'">银行账号：<van-field v-model="cf.paymentTypeBankAccount" input-align="center" style="width: 140px"/></div>
                            <div class="contract-block contract-flex" v-show="cf.paymentType === '2'">开户行：<van-field v-model="cf.paymentTypeOpenAnAccount" input-align="center" style="width: 140px"/></div>
                            <div class="contract-block contract-flex" v-show="cf.paymentType === '2'">其他：<van-field v-model="cf.paymentTypeOther" input-align="center" style="width: 140px"/></div>
                        </div>
                        <p class="contract-titles">七、甲方的权利和义务</p>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">（一）甲方的权利</div>
                            <div class="contract-block contract-flex">1.要求乙方按合同约定支付股份分红；</div>
                            <div class="contract-block contract-flex">2.按照合同约定和乙方章程规定行使成员或者股东权利；</div>
                            <div class="contract-block contract-flex">3.监督乙方按合同约定的用途依法合理利用和保护入股土地；</div>
                            <div class="contract-block contract-flex">4.制止乙方损害入股土地和农业资源的行为；</div>
                            <div class="contract-block contract-flex">5.制止乙方损害入股土地和农业资源的行为；</div>
                            <div class="contract-block contract-flex">6.其他：<van-field v-model="cf.partyRightOther" input-align="center" style="width: 140px"/></div>
                        </div>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">（二）甲方的义务</div>
                            <div class="contract-block contract-flex">1.按照合同约定交付入股土地；</div>
                            <div class="contract-block contract-flex">
                                2.合同生效后<van-field v-model="cf.partyObligationDay" input-align="center" style="width: 40px"/>日内依据《中华人民共和国农村土地承包法》第三十六条的规定向发包方备案；
                            </div>
                            <div class="contract-block contract-flex">3.不得干涉和妨碍乙方依法进行的农业生产经营活动；</div>
                            <div class="contract-block contract-flex">4.其他：<van-field v-model="cf.partyObligationOther" input-align="center" style="width: 140px"/></div>
                        </div>
                        <p class="contract-titles">八、乙方的权利和义务</p>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">（一）乙方的权利</div>
                            <div class="contract-block contract-flex">1.要求甲方按照合同约定交付入股土地；</div>
                            <div class="contract-block contract-flex">2.在合同约定的期限内占有农村土地，自主开展农业生产经营并取得收益</div>
                            <div class="contract-block contract-flex">3.经甲方同意，乙方依法投资改良土壤，建设农业生产附属、配套设施，并有权按照合同约定对其投资部分获得合理补偿；</div>
                            <div class="contract-block contract-flex">4.入股期限届满，有权在同等条件下优先续约；</div>
                            <div class="contract-block contract-flex">5.其他：<van-field v-model="cf.sPartyObligationOther" input-align="center" style="width: 140px"/></div>
                        </div>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">（二）乙方的义务</div>
                            <div class="contract-block contract-flex">1.按照合同约定及时接受入股土地并按照约定向甲方支付股份分红；</div>
                            <div class="contract-block contract-flex">2.保障甲方按照合同约定和章程规定行使成员或者股东权利；</div>
                            <div class="contract-block contract-flex">3.在法律法规政策规定和合同约定允许范围内合理利用入股土地，确保农地农用，符合当地粮食生产等产业规划，不得弃耕抛荒，不得破坏农业综合生产能力和农业生态环境；</div>
                            <div class="contract-block contract-flex">4.依据有关法律法规保护入股土地，禁止改变入股土地的农业用途，禁止占用入股土地建窑、建坟或者擅自在入股土地上建房、挖砂、采石、采矿、取土等，禁止占用入股的永久基本农田发展林果业和挖塘养鱼；</div>
                            <div class="contract-block contract-flex">5.其他：<van-field v-model="cf.sPartyObligationOther" input-align="center" style="width: 140px"/></div>
                        </div>
                        <p class="contract-titles">九、其他约定</p>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">（一）甲方同意乙方依法</div>
                            <div class="contract-block contract-flex">
                                <a-checkbox-group
                                    :options="['投资改良土壤', '建设农业生产附属、配套设施', '以土地经营权融资担保', '再流转土地经营权']"
                                    v-model:value="cf.pursuantLawAction"
                                />
                                <div class="contract-block contract-flex"><a-checkbox>其他</a-checkbox><van-field v-model="cf.pursuantLawActionOther" input-align="center" style="width: 140px"/>。</div>
                            </div>
                            <div class="contract-block contract-flex">（二）该出租土地的财政补贴等归属：<van-field v-model="cf.pursuantLawActionAffiliation" input-align="center" style="width: 80px"/></div>
                            <div class="contract-block contract-flex">
                                （三）乙方向
                                <van-field v-model="cf.sPartyPaymentPerson" input-align="center" style="width: 80px"/>
                                <a-checkbox-group
                                    :options="['缴纳', '不缴纳']"
                                    v-model:value="cf.sPartyIsPayment"
                                />
                                风险保障金<van-field v-model="cf.insuranceCoverage" input-align="center" style="width: 60px"/>元（大写：<van-field v-model="cf.insuranceCoverageUppercase" input-align="center" style="width: 100px"/>），
                                合同到期后的处理：<van-field v-model="cf.contractExpirationTreatment" input-align="center" style="width: 100px"/>
                            </div>
                            <div class="contract-block contract-flex">（四）本合同期限内，入股土地被依法征收、征用、占用时，有关地上附着物及青苗补偿费的归属：<van-field v-model="cf.compensationAffiliation" input-align="center" style="width: 80px"/></div>
                            <div class="contract-block contract-flex">（五）其他事项：<van-field v-model="cf.anyOtherBusiness" input-align="center" style="width: 140px"/></div>
                        </div>
                        <p class="contract-titles">十、合同变更、解除和终止</p>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">（一）合同有效期间，因不可抗力因素致使合同全部不能履行时，本合同自动终止，甲方将合同终止日至入股到期日的期限内已收取的股份分红退还给乙方；致使合同部分不能履行的，其他部分继续履行，股份分红可以作相应调整。</div>
                            <div class="contract-block contract-flex">（二）如乙方在合同期满后需要继续经营该入股土地，必须在合同期满前<van-field v-model="cf.modificationBeforeFullDayApply" input-align="center" style="width: 40px"/>日内书面向甲方提出申请。如乙方不再继续经营的，必须在合同期满前<van-field v-model="cf.modificationBeforeFullDayInform" input-align="center" style="width: 40px"/>日内书面通知甲方，并在合同期满后<van-field v-model="cf.modificationLaterFullDayReturn" input-align="center" style="width: 40px"/>日内将原入股的土地交还给甲方。</div>
                            <div class="contract-block">（三）合同到期或者未到期由甲方依法提前收回入股土地时，乙方依法投资建设的农业生产附属、配套设施处置方式：</div>
                            <div class="contract-block contract-flex">
                                <a-checkbox-group
                                    :options="['由甲方无偿处置。', '经有资质的第三方评估后，由甲方支付价款购买。', '经双方协商后，由甲方支付价款购买。', '由乙方恢复原状。']"
                                    v-model:value="cf.disposalMethod"
                                />
                                <div class="contract-block contract-flex"><a-checkbox>其他</a-checkbox><van-field v-model="cf.disposalMethodOther" input-align="center" style="width: 140px"/>。</div>
                            </div>
                        </div>
                        <p class="contract-titles">十一、违约责任</p>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">（一）任何一方违约给对方造成损失的，违约方应承担赔偿责任。</div>
                            <div class="contract-block contract-flex">（二）甲方应按合同规定按时向乙方交付土地，逾期一日应向乙方支付<van-field v-model="cf.partyCompensation" input-align="center" style="width: 60px"/>元（大写：<van-field v-model="cf.partyCompensationUppercase" input-align="center" style="width: 60px"/>）违约金。逾期超过<van-field v-model="cf.partyCompensationOverdue" input-align="center" style="width: 40px"/>日，乙方有权解除合同，甲方应当赔偿损失。</div>
                            <div class="contract-block">（三）甲方入股的土地存在权属纠纷或经济纠纷，致使合同全部或部分不能履行的，甲方应当赔偿损失。</div>
                            <div class="contract-block">（四）甲方违反合同约定擅自干涉和破坏乙方的生产经营,致使乙方无法进行正常的生产经营活动的，乙方有权解除合同，甲方应当赔偿损失。</div>
                            <div class="contract-block contract-flex">（五）乙方应按照合同规定按时足额向甲方支付股份分红，逾期一日应向甲方支付<van-field v-model="cf.sPartyCompensation" input-align="center" style="width: 60px"/>元（大写：<van-field v-model="cf.sPartyCompensationUppercase" input-align="center" style="width: 60px"/>）违约金。逾期超过<van-field v-model="cf.sPartyCompensationOverdue" input-align="center" style="width: 40px"/>日，甲方有权解除合同，乙方应当赔偿损失。</div>
                            <div class="contract-block">（六）乙方擅自改变入股土地的农业用途、弃耕抛荒连续两年以上、给入股土地造成严重损害或者严重破坏土地生态环境的，甲方有权解除合同、收回该土地经营权，并要求乙方赔偿损失。</div>
                            <div class="contract-block contract-flex">（七）合同期限届满的，乙方应当按照合同约定将原入股土地交还给甲方，逾期一日应向甲方支付<van-field v-model="cf.expirationSPartyCompensation" input-align="center" style="width: 60px"/>元（大写：<van-field v-model="cf.expirationSPartyCompensationUppercase" input-align="center" style="width: 60px"/>）违约金。</div>
                        </div>
                        <p class="contract-titles">十二、合同争议解决方式</p>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">本合同发生争议的，甲乙双方可以协商解决，也可以请求村民委员会、乡（镇）人民政府等调解解决。当事人不愿协商、调解或者协商、调解不成的，可以依据《中华人民共和国农村土地承包法》第五十五条的规定向农村土地承包仲裁委员会申请仲裁，也可以直接向人民法院起诉。</div>
                        </div>
                        <p class="contract-titles">十三、附则</p>
                        <div class="contract-block contract-flex">
                            <div class="contract-block">（一）本合同未尽事宜，经甲方、乙方协商一致后可签订补充协议。补充协议与本合同具有同等法律效力。</div>
                            <div class="contract-block">补充条款（可另附件）<van-field v-model="cf.supplementaryTerms" input-align="center" style="width: 140px"/></div>
                            <div class="contract-block contract-flex">（二）本合同自甲乙双方签字、盖章或者按手印之日起生效。本合同一式<van-field v-model="cf.contractCount" input-align="center" style="width: 40px"/>份，由甲方、乙方、农村集体经济组织、乡（镇）人民政府农村土地承包管理部门，<van-field v-model="cf.industryName" input-align="center" style="width: 60px"/>各执一份。</div>
                        </div>
                        <div class="contract-block contract-flex" style="color: #FA1E1E; font-size: 12px">
                            <div class="contract-block">附件名称</div>
                            <div class="contract-block">1.甲方、乙方的证件复印件</div>
                            <div class="contract-block">2.入股土地的权属证明</div>
                            <div class="contract-block">3.入股土地四至范围附图</div>
                            <div class="contract-block">4.其他（例如：附属建筑及设施清单、村民会议决议书及公示材料、代办授权委托书和证件复印件等）</div>
                        </div>
                    </div>
                </div>
                <div style="margin: 16px;">
                    <van-button round block type="primary" native-type="submit">
                        提交
                    </van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>

<script>
import { Form, Field, CellGroup, Button, Icon, Checkbox } from 'vant'
import 'vant/es/button/style'
import 'vant/es/form/style'
import 'vant/es/field/style'
import 'vant/es/cell-group/style'
import 'vant/es/icon/style'
import 'vant/es/checkbox/style'
import { reactive, ref, toRaw, computed } from 'vue'
import { villageLandManagementSharesAllSaveApi} from "../../../../api/townCenter";
import { cloneDeep } from 'lodash-es'
import {notification} from "ant-design-vue";
const columns = [
    {
        title: '序号',
        dataIndex: 'no',
        slots: {
            customRender: 'no',
        },
    },
    {
        title: '村（组）',
        dataIndex: 'village',
        slots: {
            customRender: 'village',
        },
    },
    {
        title: '地块名称',
        dataIndex: 'landParcelName',
        slots: {
            customRender: 'landParcelName',
        },
    },
    {
        title: '地块代码',
        dataIndex: 'landParcelCode',
        slots: {
            customRender: 'landParcelCode',
        },
    },
    {
        title: '坐落（东至）',
        dataIndex: 'locatedEast',
        slots: {
            customRender: 'locatedEast',
        },
    },
    {
        title: '坐落（南至）',
        dataIndex: 'locatedSouth',
        slots: {
            customRender: 'locatedSouth',
        },
    },
    {
        title: '坐落（西至）',
        dataIndex: 'locatedWest',
        slots: {
            customRender: 'locatedWest',
        },
    },
    {
        title: '坐落（北至）',
        dataIndex: 'locatedNorth',
        slots: {
            customRender: 'locatedNorth',
        },
    },
    {
        title: '面积（亩）',
        dataIndex: 'area',
        slots: {
            customRender: 'area',
        },
    },
    {
        title: '质量等级',
        dataIndex: 'qualityGrade',
        slots: {
            customRender: 'qualityGrade',
        },
    },
    {
        title: '土地类型',
        dataIndex: 'landParcelType',
        slots: {
            customRender: 'landParcelType',
        },
    },
    {
        title: '承包合同代码',
        dataIndex: 'contractCode',
        slots: {
            customRender: 'contractCode',
        },
    },
    {
        title: '备注',
        dataIndex: 'remark',
        slots: {
            customRender: 'remark',
        },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        slots: {
            customRender: 'operation',
        },
    },
]
const data = [{
    key: '1',
    no: 1,
    village: '',
    landParcelName: '',
    landParcelCode: '',
    locatedEast: '',
    locatedSouth: '',
    locatedWest: '',
    locatedNorth: '',
    area: '',
    qualityGrade: '',
    landParcelType: '',
    contractCode: '',
    remark: '',
}]
export default {
    name: "rentContract",
    setup() {
        const pageTitle = {
            cn: '股权合同',
            en: 'STAKE CONTRACT'
        }
        const dataSource = ref(data);
        const editableData = reactive({});

        const edit = key => {
            editableData[key] = cloneDeep(dataSource.value.filter(item => key === item.key)[0]);
        };

        const save = key => {
            Object.assign(dataSource.value.filter(item => key === item.key)[0], editableData[key]);
            delete editableData[key];
        };

        const cancel = key => {
            delete editableData[key];
        }
        const count = computed(() => dataSource.value.length + 1)
        const handleAdd = () => {
            const newData = {
                key: `${count.value}`,
                no: `${count.value}`,
                village: '',
                landParcelName: '',
                landParcelCode: '',
                locatedEast: '',
                locatedSouth: '',
                locatedWest: '',
                locatedNorth: '',
                area: '',
                qualityGrade: '',
                landParcelType: '',
                contractCode: '',
                remark: '',
            };
            dataSource.value.push(newData);
        }
        const username = ref('')
        const cf = reactive({
            party: '',
            partySocialCreditCode: '',
            partyIdCard: '',
            partyLegalRepresentative: '',
            partyLegalRepresentativeIdCard: '',
            partyLegalRepresentativeAddress: '',
            partyLegalRepresentativePhone: '',
            partyBusinessEntityType: [],
            partyBusinessEntityTypeOther: '',

            sParty: '',
            sPartySocialCreditCode: '',
            sPartyIdCard: '',
            sPartyLegalRepresentative: '',
            sPartyLegalRepresentativeIdCard: '',
            sPartyLegalRepresentativeAddress: '',
            sPartyLegalRepresentativePhone: '',
            sPartyBusinessEntityType: [],
            sPartyBusinessEntityTypeOther: '',

            acresCount: '',
            assetDescription: '',
            descriptionOfDisposal: '',

            landUseForLease: '',

            sharesStartTime: '',
            sharesEndTime: '',

            landDeliveryTime: '',

            perMuOther: '',
            shareStandard: '',
            shareStandardKind: '',
            pressShareKind: [],
            pressShareKindOther: '',
            minimumRevenue: '',
            minimumRevenueUppercase: '',
            minimumRevenueAdjustYear: '',
            minimumRevenueAdjust: '',
            shareReason: [],
            shareReasonOther: '',
            shareStandardOther: '',
            perMuRmb: '',
            perMuRmbUppercase: '',

            sharePayType: '',
            shareFpTime: '',

            paymentType: '',
            paymentTypePartyAccountName: '',
            paymentTypeBankAccount: '',
            paymentTypeOpenAnAccount: '',
            paymentTypeOther: '',

            partyRightOther: '',
            partyObligationDay: '',
            partyObligationOther: '',

            sPartyRightOther: '',
            sPartyObligationOther: '',

            pursuantLawAction: [],
            pursuantLawActionOther: '',
            pursuantLawActionAffiliation: '',
            sPartyPaymentPerson: '',
            sPartyIsPayment: [],
            insuranceCoverage: '',
            insuranceCoverageUppercase: '',
            contractExpirationTreatment: '',
            compensationAffiliation: '',
            anyOtherBusiness: '',

            modificationBeforeFullDayApply: '',
            modificationBeforeFullDayInform: '',
            modificationLaterFullDayReturn: '',
            shareFpType: [],
            shareRevenueFpTimeType: [],
            disposalMethod: [],
            disposalMethodOther: '',
            shareRevenueType: [],
            shareRevenueTime: '',
            shareYearMinimumRevenue: '',
            shareYearMinimumRevenueUppercase: '',
            shareRevenueFpTime: '',
            sharePayOther: '',

            partyCompensation: '',
            partyCompensationUppercase: '',
            partyCompensationOverdue: '',
            sPartyCompensation: '',
            sPartyCompensationUppercase: '',
            sPartyCompensationOverdue: '',
            expirationSPartyCompensation: '',
            expirationSPartyCompensationUppercase: '',

            supplementaryTerms: '',
            contractCount: '',
            industryName: '',
        })
        const onSubmit = () => {
            const landParcelSaveDTOList = toRaw(dataSource.value)
            const naive = toRaw(cf)
            const params = {
                "sharesPartiesMap": {
                    "party": naive.party,
                    "partySocialCreditCode": naive.partySocialCreditCode,
                    "partyIdCard": naive.partyIdCard,
                    "partyLegalRepresentative": naive.partyLegalRepresentative,
                    "partyLegalRepresentativeIdCard": naive.partyLegalRepresentativeIdCard,
                    "partyLegalRepresentativeAddress": naive.partyLegalRepresentativeAddress,
                    "partyLegalRepresentativePhone": naive.partyLegalRepresentativePhone,
                    "partyBusinessEntityType": naive.partyBusinessEntityType.toString(),
                    "partyBusinessEntityTypeOther": naive.partyBusinessEntityTypeOther,
                    "sParty": naive.sParty,
                    "sPartySocialCreditCode": naive.sPartySocialCreditCode,
                    "sPartyLegalRepresentative": naive.sPartyLegalRepresentative,
                    "sPartyLegalRepresentativeIdCard": naive.sPartyLegalRepresentativeIdCard,
                    "sPartyLegalRepresentativeAddress": naive.sPartyLegalRepresentativeAddress,
                    "sPartyLegalRepresentativePhone": naive.sPartyLegalRepresentativePhone,
                    "sPartyBusinessEntityType": naive.sPartyBusinessEntityType.toString(),
                    "sPartyBusinessEntityTypeOther": naive.sPartyBusinessEntityTypeOther
                },
                "sharesShareMap": {
                    "acresCount": naive.acresCount,
                    "landParcelSaveDTOList": landParcelSaveDTOList,
                    "assetDescription": naive.assetDescription,
                    "descriptionOfDisposal": naive.descriptionOfDisposal,
                    "landUseForLease": naive.landUseForLease,
                    "sharesStartTime": naive.sharesStartTime,
                    "sharesEndTime": naive.sharesEndTime,
                    "landDeliveryTime": naive.landDeliveryTime,
                    "shareStandard": naive.shareStandard,
                    "perMuRmb": naive.perMuRmb,
                    "perMuRmbUppercase": naive.perMuRmbUppercase,
                    "perMuOther": naive.perMuOther,
                    "shareStandardKind": naive.shareStandardKind,
                    "pressShareKind": naive.pressShareKind.toString(),
                    "pressShareKindOther": naive.pressShareKindOther,
                    "minimumRevenue": naive.minimumRevenue,
                    "minimumRevenueUppercase": naive.minimumRevenueUppercase,
                    "minimumRevenueAdjustYear": naive.minimumRevenueAdjustYear,
                    "minimumRevenueAdjust": naive.minimumRevenueAdjust,
                    "shareReason": naive.shareReason.toString(),
                    "shareReasonOther": naive.shareReasonOther,
                    "shareStandardOther": naive.shareStandardOther,
                    "sharePayType": naive.sharePayType,
                    "shareFpTime": naive.shareFpTime,
                    "shareFpType": naive.shareFpType.toString(),
                    "shareRevenueType": naive.shareRevenueType.toString(),
                    "shareYearMinimumRevenue": naive.shareYearMinimumRevenue,
                    "shareYearMinimumRevenueUppercase": naive.shareYearMinimumRevenueUppercase,
                    "shareRevenueFpTime": naive.shareRevenueFpTime,
                    "shareRevenueFpTimeType": naive.shareRevenueFpTimeType.toString(),
                    "shareRevenueTime": naive.shareRevenueTime,
                    "paymentType": naive.paymentType,
                    "paymentTypePartyAccountName": naive.paymentTypePartyAccountName,
                    "paymentTypeBankAccount": naive.paymentTypeBankAccount,
                    "paymentTypeOpenAnAccount": naive.paymentTypeOpenAnAccount,
                    "sharePayOther": naive.sharePayOther,
                },
                "sharesPartyDutyMap": {
                    "partyRightOther": naive.partyRightOther,
                    "partyObligationDay": naive.partyObligationDay,
                    "pursuantLawAction": naive.pursuantLawAction.toString(),
                    "pursuantLawActionAffiliation": naive.pursuantLawActionAffiliation,
                    "sPartyPaymentPerson": naive.sPartyPaymentPerson,
                    "sPartyIsPayment": naive.sPartyIsPayment.toString(),
                    "insuranceCoverage": naive.insuranceCoverage,
                    "insuranceCoverageUppercase": naive.insuranceCoverageUppercase,
                    "contractExpirationTreatment": naive.contractExpirationTreatment,
                    "compensationAffiliation": naive.compensationAffiliation,
                    "anyOtherBusiness": naive.anyOtherBusiness,
                    "modificationBeforeFullDayApply": naive.modificationBeforeFullDayApply,
                    "modificationBeforeFullDayInform": naive.modificationBeforeFullDayInform,
                    "modificationLaterFullDayReturn": naive.modificationLaterFullDayReturn,
                    "disposalMethod": naive.disposalMethod,
                    "partyCompensation": naive.partyCompensation,
                    "partyCompensationUppercase": naive.partyCompensationUppercase,
                    "partyCompensationOverdue": naive.partyCompensationOverdue,
                    "sPartyCompensation": naive.sPartyCompensation,
                    "sPartyCompensationUppercase": naive.sPartyCompensationUppercase,
                    "sPartyCompensationOverdue": naive.sPartyCompensationOverdue,
                    "expirationSPartyCompensation": naive.expirationSPartyCompensation,
                    "expirationSPartyCompensationUppercase": naive.expirationSPartyCompensationUppercase,
                    "contractCount": naive.contractCount,
                    "industryName": naive.industryName
                }
            }
            villageLandManagementSharesAllSaveApi(params).then((res) => {
                if (res) {
                    notification.success({ message: '提交成功！', duration: 2.5, description: '' })
                    // setTimeout(() => {
                    //     location.reload()
                    // }, 2000)
                }
            })
        }
        return {
            pageTitle,
            username,
            cf,
            onSubmit,

            dataSource,
            columns,
            editingKey: '',
            editableData,
            edit,
            save,
            cancel,
            handleAdd
        }
    },
    components: {
        [Form.name]: Form,
        [Field.name]: Field,
        [CellGroup.name]: CellGroup,
        [Button.name]: Button,
        [Icon.name]: Icon,
        [Checkbox.name]: Checkbox,
    }
}
</script>

<style scoped lang="stylus">
.pages {
    width 100%
    height 100%
    background-color #F6F7FB
    .header {
        width 100%
        height 170px
        background-image url("../../../../assets/img/town_home_bg.png")
        background-repeat no-repeat
        background-size 100% 100%
        font-size 22px
        color #FFF
        display flex
        align-items center
        justify-content center
        .header-title {
            width 100%
            text-align center
        }
        .header-title p:last-child {
            font-size 12px
        }
    }
    .container {
        width 100%
        padding 16px 0
        background-color #F6F7FB
        .form-line-title {
            font-size 14px
            color #1A1A1A
            margin-bottom 10px
            margin-left 20px
        }
        .contract {
            padding 10px 20px
            .contract-home {
                width 100%
                height 555px
                padding 25px 20px 50px 25px
                background-color #FFF
                margin-bottom 20px
                border-radius 5px
                position relative
                .contract-no {
                    font-size 14px
                    color #1F1F1F
                }
                .contract-name {
                    width 100%
                    font-size 16px
                    color #1F1F1F
                    margin-top 95px
                    text-align center
                }
                .contract-company {
                    width auto
                    font-size 12px
                    color #1F1F1F
                    position absolute
                    left 50%
                    transform translateX(-50%)
                    bottom 50px
                    text-align center
                }
                .contract-zd {
                    font-size 12px
                    color #1F1F1F
                    position absolute
                    right 70px
                    bottom 62px
                }
            }
            .contract-text {
                color #1F1F1F
                padding 14px
                background-color #FFF
                margin-bottom 20px
                border-radius 5px
                position relative
                .contract-text-title {
                    font-size 14px
                    text-align center
                }
                .contract-text-content {
                    font-size 13px
                    line-height 24px
                }
            }
            .contract-sm {
                width 100%
                font-family "Kaiti SC"
            }
            .contract-content {
                width 100%
                background-color #FFF
                padding 10px
                color #1F1F1F
                font-size 14px
                display flex
                flex-wrap wrap
                justify-content left
                border-radius 5px
                .contract-titles {
                    width 100%
                    color #1F1F1F
                    font-size 14px
                    font-weight 600
                    margin 10px 0
                }
                .contract-block {
                    width 100%
                    .contract-table {
                        width 100%
                        overflow-x auto
                        margin 10px 0
                        /deep/ table {
                            width 1600px
                        }
                    }
                }
                .contract-flex {
                    display flex
                    flex-wrap wrap
                    margin 3px 0
                    /deep/ .a-checkbox {
                        margin 5px 3px
                    }
                }
                /deep/ input {
                    border-bottom 1px solid #000 !important
                }
            }
            .contract-content input {
                border-left none
                border-top none
                border-right none
                border-bottom 1px solid #000 !important
                text-align center
            }
            /deep/ .van-cell {
                padding 0
                line-height inherit
                text-align center
            }
        }
        .upload-tip {
            color #BEBCBC
            font-size 12px
        }
    }
}
</style>
